export default "__VITE_ASSET__233af2dd__"